__turbopack_context__.v({
  "card": "style-module-scss-module__04fwQW__card",
  "cardCta": "style-module-scss-module__04fwQW__cardCta",
  "cardCtaArrow": "style-module-scss-module__04fwQW__cardCtaArrow",
  "cardCtaLabel": "style-module-scss-module__04fwQW__cardCtaLabel",
  "cardNumber": "style-module-scss-module__04fwQW__cardNumber",
  "cardRow": "style-module-scss-module__04fwQW__cardRow",
  "component": "style-module-scss-module__04fwQW__component",
  "componentNoHeader": "style-module-scss-module__04fwQW__componentNoHeader",
  "header": "style-module-scss-module__04fwQW__header",
  "imageInner": "style-module-scss-module__04fwQW__imageInner",
  "leftSection": "style-module-scss-module__04fwQW__leftSection",
  "middleSection": "style-module-scss-module__04fwQW__middleSection",
  "rightSection": "style-module-scss-module__04fwQW__rightSection",
  "wrapper": "style-module-scss-module__04fwQW__wrapper",
});
